module.exports = __webpack_public_path__ + "static/media/PC_Workshop_FUNDAMENTOS_DE_DEVOPS.e65f071e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/fundamentos-devops/PC_Workshop_FUNDAMENTOS_DE_DEVOPS.png
// module id = 249
// module chunks = 0